var Ee = Object.defineProperty, Ie = Object.defineProperties;
var Ve = Object.getOwnPropertyDescriptors;
var ve = Object.getOwnPropertySymbols;
var Oe = Object.prototype.hasOwnProperty, je = Object.prototype.propertyIsEnumerable;
var me = (x, b, w) => b in x ? Ee(x, b, { enumerable: !0, configurable: !0, writable: !0, value: w }) : x[b] = w, te = (x, b) => {
  for (var w in b || (b = {}))
    Oe.call(b, w) && me(x, w, b[w]);
  if (ve)
    for (var w of ve(b))
      je.call(b, w) && me(x, w, b[w]);
  return x;
}, ce = (x, b) => Ie(x, Ve(b));
var J = (x, b, w) => new Promise((j, i) => {
  var S = (g) => {
    try {
      l(w.next(g));
    } catch (c) {
      i(c);
    }
  }, n = (g) => {
    try {
      l(w.throw(g));
    } catch (c) {
      i(c);
    }
  }, l = (g) => g.done ? j(g.value) : Promise.resolve(g.value).then(S, n);
  l((w = w.apply(x, b)).next());
});
import "../../../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import qe from "../formMixin.js";
import { postRuleValidate as he } from "../../../../request/commoditycenter/form/ruleValidate/post.js";
import { postCodes as Le } from "../../../../request/commoditycenter/commodity/classification/dictionary/rela/codes/post.js";
import { useLanguage as Pe } from "../../../../utils/useLanguage.js";
import { defineComponent as $e, useTemplateRef as De, watch as R, computed as T, onMounted as Je, openBlock as Te, createElementBlock as Ge, createElementVNode as v, createVNode as t, withCtx as a, createTextVNode as m, withDirectives as Ke, Fragment as Qe } from "../../../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useMessage as Xe } from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import { ref as h, unref as e } from "../../../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import V from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import Ye from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import we from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/Form.js";
import { toDisplayString as r } from "../../../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
import be from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/legacy-grid/src/Row.js";
import p from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/legacy-grid/src/Col.js";
import f from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/FormItem.js";
import M from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/select/src/Select.js";
import A from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/input-number/src/InputNumber.js";
import H from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/radio/src/RadioGroup.js";
import C from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/radio/src/Radio.js";
import Ze from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/input/src/Input.js";
import O from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import { vShow as el } from "../../../../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import ge from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
const ll = { class: "explain mb-4 tw:space-y-2" }, tl = { class: "tw:m-0 tw:mb-2 tw:font-bold" }, al = { class: "tw:text-[#909399] tw:m-0 tw:my-2" }, ol = { class: "tw:text-[#303133] tw:font-bold" }, dl = { class: "tw:text-[#909399] tw:m-0 tw:my-2" }, il = { class: "tw:text-[#303133] tw:font-bold" }, sl = { class: "tw:text-[#909399] tw:m-0 tw:my-2" }, ul = { class: "tw:text-[#303133] tw:font-bold" }, nl = { class: "tw:flex tw:items-center" }, rl = { class: "tw:flex tw:items-center" }, pl = { class: "tw:text-[#909399]" }, fl = { class: "senior-search w-full tw:mt-4 tw:pt-4 tw:border-t tw:border-dashed tw:border-[#e5e6eb]" }, vl = { class: "tw:flex tw:justify-center tw:gap-2 tw:mt-4" }, ml = { class: "tw:flex tw:justify-center tw:gap-2" }, Ol = /* @__PURE__ */ $e({
  inheritAttrs: !1,
  __name: "lianshen",
  props: {
    options: {},
    locale: {}
  },
  emits: ["hide-dialog", "onSuccess"],
  setup(x, { expose: b, emit: w }) {
    const { i18n: j } = Pe(), { t: i } = j.global, S = De("lianshen"), { formSelect: n, formData: l, rules: g, allowEditFun: c, setDefault: Ce, setRequired: xe } = qe(), N = Xe(), k = x;
    R(
      () => k.locale,
      (u) => {
        j.global.locale.value = u || "zh-CN";
      },
      { immediate: !0 }
    );
    const G = w, W = h(!1), q = h(!1), K = h(!0), U = h(!1);
    h([]);
    const _ = h(null), Me = h(null), We = h(null), L = h(!1), Q = h(!1), P = h(!1), X = h(!1), Y = h(!1), y = h(!1), B = h(!1), ae = h(!1), z = h(!1), F = h(!1), E = h(!1), Z = h(0), ye = T(() => Number(l.leftCurtainWidth || 0) + Number(l.middleCurtainWidth || 0) + Number(l.rightCurtainWidth || 0)), _e = T(() => {
      var d;
      return !((d = (n.value.find(({ code: s }) => s === "pillow") || {}).allowEdit) != null ? d : 1) || B.value;
    }), Ne = T(() => {
      var d;
      return !((d = (n.value.find(({ code: s }) => s === "coverRail") || {}).allowEdit) != null ? d : 1) || y.value || l.productHeight > 1800;
    }), oe = T(() => l.hole > 0 || l.diagonalCurtain !== "无" ? "是" : "否"), de = (u) => {
      console.log("changeSplic", u), u === "ABC" ? (B.value = !0, y.value = !0) : (B.value = !1, y.value = !1), u !== "ABC" ? (Y.value = !0, l.clothC = "") : Y.value = !1, u === "A" ? (X.value = !0, L.value = !0, Q.value = !0, P.value = !0, l.clothMath = "无", l.clothB = "") : (X.value = !1, L.value = !1, Q.value = !1, P.value = !1, l.clothMath = "2");
    }, ke = (u) => {
      l.pleatinMultiple = u === i("平拉帘") ? "2.1" : "2.4";
    }, ee = (u, o = !0) => {
      switch (u) {
        case "左单开":
          z.value = !1, F.value = !0, E.value = !0, o && $(u);
          break;
        case "右单开":
          z.value = !0, F.value = !1, E.value = !0, o && $(u);
          break;
        case "双开":
          z.value = !1, F.value = !1, E.value = !0, o && $(u);
          break;
        case "三开":
          z.value = !1, F.value = !1, E.value = !1, o && $(u);
          break;
      }
    }, $ = (u) => {
      if (l.productWidth)
        switch (u) {
          case "左单开":
            l.leftCurtainWidth = l.productWidth, l.middleCurtainWidth = 0, l.rightCurtainWidth = 0;
            break;
          case "右单开":
            l.leftCurtainWidth = 0, l.middleCurtainWidth = 0, l.rightCurtainWidth = l.productWidth;
            break;
          case "双开":
            l.leftCurtainWidth = Math.round(l.productWidth / 2 * 100) / 100, l.middleCurtainWidth = 0;
            let o = Math.round(l.productWidth / 2 * 100) / 100;
            l.rightCurtainWidth = l.productWidth - (l.leftCurtainWidth + o) + o;
            break;
          case "三开":
            l.leftCurtainWidth = Math.round(l.productWidth / 3 * 100) / 100, l.middleCurtainWidth = Math.round(l.productWidth / 3 * 100) / 100;
            let d = Math.round(l.productWidth / 3 * 100) / 100;
            l.rightCurtainWidth = l.productWidth - (l.leftCurtainWidth + l.middleCurtainWidth + d) + d;
            break;
        }
    }, ie = () => {
      G("hide-dialog");
    }, D = () => {
      console.log("选择改变");
    }, se = () => {
      var u;
      l.pillow === "是" ? (g.pillowNum = [{
        required: !0,
        message: "请计算抱枕数量",
        trigger: ["blur", "change", "input"],
        // 添加自定义验证函数，明确允许0值
        validator: (o, d) => d == null || d === "" ? new Error("请计算抱枕数量") : !0
      }], g.pillowModel = [{ required: !0, message: "请选择抱枕型号", trigger: ["blur", "change"] }], l.pillowModel = "普通", Z.value = 1, y.value = !0, l.coverRail = "否", console.log("rules", g)) : (delete g.pillowNum, delete g.pillowModel, console.log("rules", g), (u = _ == null ? void 0 : _.value) == null || u.restoreValidation(), l.pillowModel = "", Z.value = 0, y.value = !1);
    }, Ae = () => {
      ye.value > (l.productWidth || 0) ? N.error(i("各帘宽之和不得大于成品宽！")) : U.value = !1;
    }, ue = (u) => {
      u === "show" && (l.leftCurtainWidth || l.middleCurtainWidth || l.rightCurtainWidth) ? console.log("不需要初始化数据") : l.openModel && ee(l.openModel), u === "show" && (U.value = !0);
    }, He = () => J(this, null, function* () {
      var o;
      l.isStandard = oe.value, ce(te({}, l), {
        roomName: "",
        remark: ""
      }), l.attachments && l.attachments.length > 0 && (l.remark = "加工见附件"), W.value = !0;
      const u = yield he([
        {
          data: JSON.stringify(l),
          classificationCode: "FL_lianshen"
        }
      ]);
      W.value = !1, u.status ? (N.success(i("操作成功")), l.pillowNum = (o = u.data) == null ? void 0 : o.pillowNum, _.value && _.value.restoreValidation()) : N.error(u.message || "操作失败，请检查输入项");
    }), Ue = () => J(this, null, function* () {
      if (_.value)
        try {
          if (yield _.value.validate(), l.isStandard = oe.value, (l.hole > 0 || l.diagonalCurtain !== "无" || l.splicingMode === "ABC" || l.splicingMode === "BAB") && l.attachments && l.attachments.length === 0) {
            N.error("请上传附件");
            return;
          }
          if (l.attachments && l.attachments.length > 0 && (l.remark = "加工见附件"), l.coverRail === "是" && !re())
            return N.error("拼接方式为A或AB拼且定高面料才可做平幔遮轨");
          W.value = !0;
          const u = yield he([
            {
              data: JSON.stringify(l),
              classificationCode: "FL_lianshen"
            }
          ]);
          W.value = !1, u.status && (N.success("操作成功"), G("onSuccess", te({}, l)), G("hide-dialog"));
        } catch (u) {
          W.value = !1, console.error("表单提交失败:", u);
        }
    }), ne = () => J(this, null, function* () {
      var d;
      const { commodityId: u } = k.options;
      if (u === void 0) {
        console.warn("commodityId 未定义，跳过请求");
        return;
      }
      const o = {
        commodityId: String(u),
        classificationCode: "FL_lianshen",
        codes: []
      };
      n.value = [], W.value = !0;
      try {
        const s = yield Le(o);
        if (W.value = !1, s) {
          n.value = s;
          const pe = k.options.model ? k.options.model.split(",").map((I) => ({
            value: I,
            valueCode: I,
            default: !1
          })) : [], Fe = k.options.clothMode ? k.options.clothMode.split(",").map((I) => ({
            value: I,
            valueCode: I,
            default: !1
          })) : [];
          l.mainA = ((d = pe[0]) == null ? void 0 : d.value) || "", n.value.push({ code: "model", values: pe }), n.value.push({ code: "clothMode", values: Fe });
          const fe = [
            { type: "string", name: "splicingMode", message: i("请选择拼接方式") },
            { type: "string", name: "customize", message: i("请选择加工方式") },
            { type: "string", name: "pleatinMultiple", message: i("请选择打褶倍数") },
            { type: "string", name: "openModel", message: i("请选择开合方式") },
            { type: "string", name: "mainA", message: i("请选择主布A型号") },
            { type: "number", name: "productHeight", message: i("") },
            { type: "number", name: "productWidth", message: i("") },
            { type: "string", name: "roomName", message: i("") },
            { type: "string", name: "deliveryMethod", message: i("请选择配送方式") },
            { type: "string", name: "urgent", message: "" },
            { type: "number", name: "pillowNum", message: "" }
          ];
          xe(fe, s), Ce(fe, s), le(), se();
        }
      } catch (s) {
        W.value = !1, console.error("获取分类数据失败:", s);
      }
    }), Be = () => {
      Object.assign(l, {
        splicingMode: "",
        flower: "",
        customize: "",
        pleatinMultiple: "",
        clothMath: "",
        openModel: "",
        mainA: "",
        clothB: "",
        clothC: "",
        pillow: "否",
        pillowNum: 0,
        stereotype: "是",
        productModel: "",
        fixedWidthHeight: "",
        hole: 0,
        diagonalCurtain: "无",
        coverRail: "否",
        collageHeight: "",
        topCoverRail: "",
        attachments: [],
        isStandard: "否",
        productWidth: null,
        productHeight: null,
        roomName: "",
        urgent: "否",
        deliveryMethod: "",
        leftCurtainWidth: null,
        middleCurtainWidth: null,
        rightCurtainWidth: null,
        pillowModel: null
      });
    }, re = () => ["A", "AB左右拼", "AB上下拼(A上)", "AB上下拼(A下)"].includes(l.splicingMode) && ["定高", "定宽改定高"].includes(l.fixedWidthHeight), Re = (u) => {
      u !== "定高" && u !== "定宽改定高" ? y.value = !0 : y.value = !1, (u === "定高" || u === "定宽改定高") && (l.productHeight || 0) >= 1800 ? (y.value = !0, l.coverRail = "否") : y.value = !1;
    }, Se = (u) => {
      u === "是" ? (B.value = !0, l.pillow = "否") : B.value = !1;
    }, le = () => {
      ((l.productHeight || 0) > 1800 || ["定宽", "定高改定宽"].includes(l.fixedWidthHeight)) && (B.value = !0, l.pillow = "否"), y.value = (l.productHeight || 0) > 1800 || ["定宽", "定高改定宽"].includes(l.fixedWidthHeight), l.productHeight > 1800 && (l.coverRail = "否");
    }, ze = () => {
    };
    return R(() => l.productHeight, le), R(() => l.fixedWidthHeight, le), R(
      () => l.pillow,
      (u) => {
        se(), ae.value = u === "是";
      },
      { immediate: !0 }
    ), R(
      () => l.coverRail,
      (u) => {
        u === "是" && (re() || N.error("拼接方式为A或AB拼且定高面料才可做平幔遮轨"));
      }
    ), R(
      () => k.options,
      (u) => {
        Be(), Object.keys(l).forEach((d) => {
          const s = d;
          u[s] !== void 0 && (l[s] = u[s]);
        }), l.mainA = u.model ? u.model.split(",")[0] : "", l.splicingMode === "A" && (L.value = !0, Q.value = !0, P.value = !0, l.clothMath = "无");
        const o = !(l.leftCurtainWidth || l.middleCurtainWidth || l.rightCurtainWidth);
        l.openModel && ee(l.openModel, o), ne(), de(l.splicingMode);
      },
      { immediate: !0, deep: !0 }
    ), Je(() => {
      ne();
      const u = sessionStorage.getItem("userInfo");
      We.value = u ? JSON.parse(u) : null;
    }), b({
      lianshenForm: _,
      loading: W,
      isShowDialog: K,
      formData: l
    }), (u, o) => (Te(), Ge(Qe, null, [
      v("div", {
        ref_key: "lianshen",
        ref: S
      }, null, 512),
      t(e(ge), {
        bordered: "",
        show: K.value,
        "onUpdate:show": o[26] || (o[26] = (d) => K.value = d),
        "mask-closable": !1,
        to: S.value || "body"
      }, {
        default: a(() => [
          t(e(V), {
            class: "tw:!w-[50%] tw:!box-border tw:!text-left",
            title: e(i)("帘身"),
            bordered: !1,
            role: "dialog",
            closable: "",
            "header-class": "tw:!text-center",
            onClose: ie
          }, {
            default: a(() => [
              t(e(Ye), { show: W.value }, {
                default: a(() => [
                  t(e(we), {
                    model: e(l),
                    rules: e(g),
                    ref_key: "lianshenForm",
                    ref: _,
                    "label-placement": "left",
                    "label-width": "140px",
                    class: "tw:!text-left",
                    "require-mark-placement": "right-hanging",
                    size: "small"
                  }, {
                    default: a(() => [
                      t(e(V), null, {
                        default: a(() => [
                          v("div", ll, [
                            v("h3", tl, r(e(i)("下单说明")) + "：", 1),
                            v("p", al, [
                              v("span", ol, r(e(i)("BAB拼接")) + "：", 1),
                              m(r(e(i)(
                                "主布为窗帘大面积色，单价系数为1.2，下单请参照“两色三拼接图示”提供画图信息并上传"
                              )), 1)
                            ]),
                            v("p", dl, [
                              v("span", il, r(e(i)("ABC拼接")) + "：", 1),
                              m(r(e(i)("主布为窗帘大面积色，单价系数为1.2，下单请参照“三色拼接图示”提供画图信息并上传")), 1)
                            ]),
                            v("p", sl, [
                              v("span", ul, r(e(i)("平幔遮轨")) + "：", 1),
                              m(r(e(i)("默认6公分普通平幔，车缝魔术贴，默认反贴，无法选择帘幔高度")), 1)
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      t(e(V), { style: { margin: "10px 0" } }, {
                        default: a(() => [
                          t(e(be), null, {
                            default: a(() => [
                              t(e(p), { span: 12 }, {
                                default: a(() => [
                                  t(e(f), {
                                    label: e(i)("拼接方式"),
                                    path: "splicingMode",
                                    class: "tw:mb-4"
                                  }, {
                                    default: a(() => {
                                      var d;
                                      return [
                                        t(e(M), {
                                          disabled: !e(c)(e(n), "splicingMode"),
                                          value: e(l).splicingMode,
                                          "onUpdate:value": [
                                            o[0] || (o[0] = (s) => e(l).splicingMode = s),
                                            de
                                          ],
                                          placeholder: e(i)("请选择拼接方式"),
                                          options: ((d = e(n).find((s) => s.code === "splicingMode")) == null ? void 0 : d.values) || [],
                                          "label-field": "value",
                                          "value-field": "valueCode",
                                          "key-field": "valueCode",
                                          class: "tw:!w-[200px] tw:!text-left",
                                          to: !1
                                        }, null, 8, ["disabled", "value", "placeholder", "options"])
                                      ];
                                    }),
                                    _: 1
                                  }, 8, ["label"])
                                ]),
                                _: 1
                              }),
                              t(e(p), { span: 12 }, {
                                default: a(() => [
                                  t(e(f), {
                                    label: e(i)("加工方式"),
                                    path: "customize",
                                    class: "tw:mb-4"
                                  }, {
                                    default: a(() => {
                                      var d;
                                      return [
                                        t(e(M), {
                                          disabled: !e(c)(e(n), "customize"),
                                          value: e(l).customize,
                                          "onUpdate:value": [
                                            o[1] || (o[1] = (s) => e(l).customize = s),
                                            ke
                                          ],
                                          placeholder: e(i)("请选择加工方式"),
                                          options: ((d = e(n).find((s) => s.code === "customize")) == null ? void 0 : d.values) || [],
                                          "label-field": "value",
                                          "value-field": "valueCode",
                                          "key-field": "valueCode",
                                          class: "tw:!w-[200px] tw:!text-left",
                                          to: !1
                                        }, null, 8, ["disabled", "value", "placeholder", "options"])
                                      ];
                                    }),
                                    _: 1
                                  }, 8, ["label"])
                                ]),
                                _: 1
                              }),
                              t(e(p), { span: 12 }, {
                                default: a(() => [
                                  t(e(f), {
                                    label: e(i)("打褶倍数"),
                                    path: "pleatinMultiple",
                                    class: "tw:mb-4"
                                  }, {
                                    default: a(() => {
                                      var d;
                                      return [
                                        t(e(M), {
                                          disabled: !e(c)(e(n), "pleatinMultiple"),
                                          value: e(l).pleatinMultiple,
                                          "onUpdate:value": o[2] || (o[2] = (s) => e(l).pleatinMultiple = s),
                                          placeholder: e(i)("请选择打褶倍数"),
                                          options: ((d = e(n).find((s) => s.code === "pleatinMultiple")) == null ? void 0 : d.values) || [],
                                          "label-field": "value",
                                          "value-field": "valueCode",
                                          "key-field": "valueCode",
                                          class: "tw:!w-[200px] tw:!text-left",
                                          to: !1
                                        }, null, 8, ["disabled", "value", "placeholder", "options"])
                                      ];
                                    }),
                                    _: 1
                                  }, 8, ["label"])
                                ]),
                                _: 1
                              }),
                              t(e(p), { span: 12 }, {
                                default: a(() => [
                                  t(e(f), {
                                    label: e(i)("配布拼褶"),
                                    path: "clothMath",
                                    class: "tw:mb-4"
                                  }, {
                                    default: a(() => {
                                      var d;
                                      return [
                                        t(e(M), {
                                          disabled: L.value,
                                          value: e(l).clothMath,
                                          "onUpdate:value": o[3] || (o[3] = (s) => e(l).clothMath = s),
                                          placeholder: e(i)("请选择配布拼褶"),
                                          options: ((d = e(n).find((s) => s.code === "clothMath")) == null ? void 0 : d.values) || [],
                                          "label-field": "value",
                                          "value-field": "valueCode",
                                          "key-field": "valueCode",
                                          class: "tw:!w-[200px] tw:!text-left",
                                          to: !1
                                        }, null, 8, ["disabled", "value", "placeholder", "options"])
                                      ];
                                    }),
                                    _: 1
                                  }, 8, ["label"])
                                ]),
                                _: 1
                              }),
                              t(e(p), { span: 12 }, {
                                default: a(() => [
                                  t(e(f), {
                                    label: e(i)("开合方式"),
                                    path: "openModel",
                                    class: "tw:mb-4"
                                  }, {
                                    default: a(() => {
                                      var d;
                                      return [
                                        t(e(M), {
                                          disabled: !e(c)(e(n), "openModel"),
                                          value: e(l).openModel,
                                          "onUpdate:value": [
                                            o[4] || (o[4] = (s) => e(l).openModel = s),
                                            ee
                                          ],
                                          placeholder: e(i)("请选择开合方式"),
                                          options: ((d = e(n).find((s) => s.code === "openModel")) == null ? void 0 : d.values) || [],
                                          "label-field": "value",
                                          "value-field": "valueCode",
                                          "key-field": "valueCode",
                                          class: "tw:!w-[200px] tw:!text-left",
                                          to: !1
                                        }, null, 8, ["disabled", "value", "placeholder", "options"])
                                      ];
                                    }),
                                    _: 1
                                  }, 8, ["label"])
                                ]),
                                _: 1
                              }),
                              t(e(p), { span: 12 }, {
                                default: a(() => [
                                  t(e(f), {
                                    label: e(i)("主布A型号"),
                                    path: "mainA",
                                    class: "tw:mb-4"
                                  }, {
                                    default: a(() => {
                                      var d;
                                      return [
                                        t(e(M), {
                                          value: e(l).mainA,
                                          "onUpdate:value": o[5] || (o[5] = (s) => e(l).mainA = s),
                                          disabled: X.value,
                                          placeholder: e(i)("请选择主布A型号"),
                                          options: ((d = e(n).find((s) => s.code === "model")) == null ? void 0 : d.values) || [],
                                          "label-field": "value",
                                          "value-field": "valueCode",
                                          "key-field": "valueCode",
                                          class: "tw:!w-[200px] tw:!text-left",
                                          to: !1
                                        }, null, 8, ["value", "disabled", "placeholder", "options"])
                                      ];
                                    }),
                                    _: 1
                                  }, 8, ["label"])
                                ]),
                                _: 1
                              }),
                              t(e(p), { span: 12 }, {
                                default: a(() => [
                                  t(e(f), {
                                    label: e(i)("配布B型号"),
                                    path: "clothB",
                                    class: "tw:mb-4"
                                  }, {
                                    default: a(() => {
                                      var d;
                                      return [
                                        t(e(M), {
                                          disabled: P.value,
                                          value: e(l).clothB,
                                          "onUpdate:value": o[6] || (o[6] = (s) => e(l).clothB = s),
                                          placeholder: e(i)("请选择配布B型号"),
                                          "label-field": "value",
                                          "value-field": "valueCode",
                                          "key-field": "valueCode",
                                          class: "tw:!w-[200px] tw:!text-left",
                                          to: !1,
                                          options: ((d = e(n).find((s) => s.code === "clothMode")) == null ? void 0 : d.values) || []
                                        }, null, 8, ["disabled", "value", "placeholder", "options"])
                                      ];
                                    }),
                                    _: 1
                                  }, 8, ["label"])
                                ]),
                                _: 1
                              }),
                              t(e(p), { span: 12 }, {
                                default: a(() => [
                                  t(e(f), {
                                    label: e(i)("配布C型号"),
                                    path: "clothC",
                                    class: "tw:mb-4"
                                  }, {
                                    default: a(() => {
                                      var d;
                                      return [
                                        t(e(M), {
                                          disabled: Y.value,
                                          value: e(l).clothC,
                                          "onUpdate:value": o[7] || (o[7] = (s) => e(l).clothC = s),
                                          placeholder: e(i)("请选择配布C型号"),
                                          "label-field": "value",
                                          "value-field": "valueCode",
                                          "key-field": "valueCode",
                                          class: "tw:!w-[200px] tw:!text-left",
                                          to: !1,
                                          options: ((d = e(n).find((s) => s.code === "clothMode")) == null ? void 0 : d.values) || []
                                        }, null, 8, ["disabled", "value", "placeholder", "options"])
                                      ];
                                    }),
                                    _: 1
                                  }, 8, ["label"])
                                ]),
                                _: 1
                              }),
                              t(e(p), { span: 12 }, {
                                default: a(() => [
                                  t(e(f), {
                                    label: e(i)("成品高"),
                                    path: "productHeight",
                                    class: "tw:mb-4"
                                  }, {
                                    default: a(() => [
                                      t(e(A), {
                                        "show-button": !1,
                                        disabled: !e(c)(e(n), "productHeight"),
                                        value: e(l).productHeight,
                                        "onUpdate:value": o[8] || (o[8] = (d) => e(l).productHeight = d),
                                        min: 0,
                                        class: "tw:!w-[200px] tw:!text-center"
                                      }, {
                                        suffix: a(() => o[33] || (o[33] = [
                                          v("span", null, "mm", -1)
                                        ])),
                                        _: 1
                                      }, 8, ["disabled", "value"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"])
                                ]),
                                _: 1
                              }),
                              t(e(p), { span: 12 }, {
                                default: a(() => [
                                  t(e(f), {
                                    label: e(i)("成品宽"),
                                    path: "productWidth",
                                    class: "tw:mb-4"
                                  }, {
                                    default: a(() => [
                                      v("div", nl, [
                                        t(e(A), {
                                          "show-button": !1,
                                          disabled: !e(c)(e(n), "productWidth"),
                                          value: e(l).productWidth,
                                          "onUpdate:value": [
                                            o[9] || (o[9] = (d) => e(l).productWidth = d),
                                            ue
                                          ],
                                          min: 0,
                                          class: "tw:!w-[140px] tw:!text-center"
                                        }, {
                                          suffix: a(() => o[34] || (o[34] = [
                                            v("span", null, "mm", -1)
                                          ])),
                                          _: 1
                                        }, 8, ["disabled", "value"]),
                                        v("span", {
                                          onClick: o[10] || (o[10] = (d) => ue("show")),
                                          class: "tw:cursor-pointer tw:text-[#fc9153] tw:ml-[10px]"
                                        }, r(e(i)("尺寸定制")), 1)
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["label"])
                                ]),
                                _: 1
                              }),
                              t(e(p), { span: 12 }, {
                                default: a(() => [
                                  t(e(f), {
                                    label: e(i)("余料做抱枕"),
                                    path: "pillow",
                                    class: "tw:mb-4"
                                  }, {
                                    default: a(() => [
                                      t(e(H), {
                                        disabled: _e.value,
                                        value: e(l).pillow,
                                        "onUpdate:value": o[11] || (o[11] = (d) => e(l).pillow = d)
                                      }, {
                                        default: a(() => [
                                          t(e(C), { value: "是" }, {
                                            default: a(() => [
                                              m(r(e(i)("是")), 1)
                                            ]),
                                            _: 1
                                          }),
                                          t(e(C), { value: "否" }, {
                                            default: a(() => [
                                              m(r(e(i)("否")), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["disabled", "value"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"])
                                ]),
                                _: 1
                              }),
                              t(e(p), { span: 12 }, {
                                default: a(() => [
                                  t(e(f), {
                                    label: e(i)("抱枕数量"),
                                    path: "pillowNum",
                                    class: "tw:mb-4"
                                  }, {
                                    default: a(() => [
                                      v("div", rl, [
                                        t(e(A), {
                                          value: e(l).pillowNum,
                                          "onUpdate:value": o[12] || (o[12] = (d) => e(l).pillowNum = d),
                                          disabled: !e(c)(e(n), "pillowNum"),
                                          "show-button": !1,
                                          min: 0,
                                          class: "tw:!w-[140px] tw:!text-center"
                                        }, {
                                          suffix: a(() => o[35] || (o[35] = [
                                            v("span", null, "个", -1)
                                          ])),
                                          _: 1
                                        }, 8, ["value", "disabled"]),
                                        v("span", {
                                          onClick: He,
                                          class: "tw:cursor-pointer tw:text-[#fc9153] tw:ml-[10px]"
                                        }, r(e(i)("计算")), 1)
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["label"])
                                ]),
                                _: 1
                              }),
                              t(e(p), { span: 12 }, {
                                default: a(() => [
                                  t(e(f), {
                                    label: e(i)("抱枕型号"),
                                    path: "pillowModel",
                                    class: "tw:mb-4"
                                  }, {
                                    default: a(() => {
                                      var d;
                                      return [
                                        t(e(M), {
                                          disabled: !Z.value,
                                          value: e(l).pillowModel,
                                          "onUpdate:value": [
                                            o[13] || (o[13] = (s) => e(l).pillowModel = s),
                                            ze
                                          ],
                                          placeholder: e(i)("请选择抱枕型号"),
                                          options: ((d = e(n).find((s) => s.code === "pillowModel")) == null ? void 0 : d.values) || [],
                                          "label-field": "value",
                                          "value-field": "valueCode",
                                          "key-field": "valueCode",
                                          class: "tw:!w-[200px] tw:!text-left",
                                          to: !1
                                        }, null, 8, ["disabled", "value", "placeholder", "options"])
                                      ];
                                    }),
                                    _: 1
                                  }, 8, ["label"])
                                ]),
                                _: 1
                              }),
                              t(e(p), { span: 12 }, {
                                default: a(() => [
                                  t(e(f), {
                                    label: e(i)("是否对花"),
                                    path: "flower",
                                    class: "tw:mb-4"
                                  }, {
                                    default: a(() => [
                                      t(e(H), {
                                        disabled: !e(c)(e(n), "flower"),
                                        value: e(l).flower,
                                        "onUpdate:value": [
                                          o[14] || (o[14] = (d) => e(l).flower = d),
                                          D
                                        ]
                                      }, {
                                        default: a(() => [
                                          t(e(C), { value: "是" }, {
                                            default: a(() => [
                                              m(r(e(i)("是")), 1)
                                            ]),
                                            _: 1
                                          }),
                                          t(e(C), { value: "否" }, {
                                            default: a(() => [
                                              m(r(e(i)("否")), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["disabled", "value"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"])
                                ]),
                                _: 1
                              }),
                              t(e(p), { span: 12 }, {
                                default: a(() => [
                                  t(e(f), {
                                    label: e(i)("是否定型"),
                                    path: "stereotype",
                                    class: "tw:mb-4"
                                  }, {
                                    default: a(() => [
                                      t(e(H), {
                                        disabled: !e(c)(e(n), "stereotype"),
                                        value: e(l).stereotype,
                                        "onUpdate:value": [
                                          o[15] || (o[15] = (d) => e(l).stereotype = d),
                                          D
                                        ]
                                      }, {
                                        default: a(() => [
                                          t(e(C), { value: "是" }, {
                                            default: a(() => [
                                              m(r(e(i)("是")), 1)
                                            ]),
                                            _: 1
                                          }),
                                          t(e(C), { value: "否" }, {
                                            default: a(() => [
                                              m(r(e(i)("否")), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["disabled", "value"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"])
                                ]),
                                _: 1
                              }),
                              t(e(p), { span: 12 }, {
                                default: a(() => [
                                  t(e(f), {
                                    label: e(i)("房间名"),
                                    path: "roomName",
                                    class: "tw:mb-4"
                                  }, {
                                    default: a(() => [
                                      t(e(Ze), {
                                        disabled: !e(c)(e(n), "roomName"),
                                        value: e(l).roomName,
                                        "onUpdate:value": o[16] || (o[16] = (d) => e(l).roomName = d),
                                        class: "tw:!w-[200px]"
                                      }, null, 8, ["disabled", "value"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"])
                                ]),
                                _: 1
                              }),
                              t(e(p), { span: 12 }, {
                                default: a(() => [
                                  t(e(f), {
                                    label: e(i)("配送方式"),
                                    path: "deliveryMethod",
                                    class: "tw:mb-4"
                                  }, {
                                    default: a(() => {
                                      var d;
                                      return [
                                        t(e(M), {
                                          disabled: !e(c)(e(n), "deliveryMethod"),
                                          value: e(l).deliveryMethod,
                                          "onUpdate:value": o[17] || (o[17] = (s) => e(l).deliveryMethod = s),
                                          placeholder: e(i)("请选择配送方式"),
                                          options: ((d = e(n).find((s) => s.code === "deliveryMethod")) == null ? void 0 : d.values) || [],
                                          "label-field": "value",
                                          "value-field": "valueCode",
                                          "key-field": "valueCode",
                                          class: "tw:!w-[200px] tw:!text-left",
                                          to: !1
                                        }, null, 8, ["disabled", "value", "placeholder", "options"])
                                      ];
                                    }),
                                    _: 1
                                  }, 8, ["label"])
                                ]),
                                _: 1
                              }),
                              t(e(p), { span: 12 }, {
                                default: a(() => [
                                  t(e(f), {
                                    label: e(i)("是否加急"),
                                    path: "urgent",
                                    class: "tw:mb-4"
                                  }, {
                                    default: a(() => [
                                      t(e(H), {
                                        disabled: !e(c)(e(n), "urgent"),
                                        value: e(l).urgent,
                                        "onUpdate:value": o[18] || (o[18] = (d) => e(l).urgent = d)
                                      }, {
                                        default: a(() => [
                                          t(e(C), { value: "是" }, {
                                            default: a(() => [
                                              m(r(e(i)("是")), 1)
                                            ]),
                                            _: 1
                                          }),
                                          t(e(C), { value: "否" }, {
                                            default: a(() => [
                                              m(r(e(i)("否")), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["disabled", "value"]),
                                      v("span", pl, "  (" + r(e(i)("注：加急需收取加急费35元")) + ") ", 1)
                                    ]),
                                    _: 1
                                  }, 8, ["label"])
                                ]),
                                _: 1
                              }),
                              t(e(p), { span: 24 }, {
                                default: a(() => [
                                  t(e(O), {
                                    type: "primary",
                                    size: "small",
                                    onClick: o[19] || (o[19] = (d) => q.value = !q.value)
                                  }, {
                                    default: a(() => [
                                      m(r(q.value ? e(i)("收起") : e(i)("展开更多")), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              Ke(v("div", fl, [
                                t(e(p), { span: 12 }, {
                                  default: a(() => [
                                    t(e(f), {
                                      label: e(i)("定宽/定高"),
                                      path: "fixedWidthHeight",
                                      class: "tw:mb-4"
                                    }, {
                                      default: a(() => {
                                        var d;
                                        return [
                                          t(e(M), {
                                            disabled: !e(c)(e(n), "fixedWidthHeight") || ae.value,
                                            value: e(l).fixedWidthHeight,
                                            "onUpdate:value": [
                                              o[20] || (o[20] = (s) => e(l).fixedWidthHeight = s),
                                              Re
                                            ],
                                            placeholder: e(i)("请选择定宽/定高"),
                                            options: ((d = e(n).find((s) => s.code === "fixedWidthHeight")) == null ? void 0 : d.values) || [],
                                            "label-field": "value",
                                            "value-field": "valueCode",
                                            "key-field": "valueCode",
                                            class: "tw:!w-[200px] tw:!text-left",
                                            to: !1
                                          }, null, 8, ["disabled", "value", "placeholder", "options"])
                                        ];
                                      }),
                                      _: 1
                                    }, 8, ["label"])
                                  ]),
                                  _: 1
                                }),
                                t(e(p), { span: 12 }, {
                                  default: a(() => [
                                    t(e(f), {
                                      label: e(i)("异形挖孔数"),
                                      path: "hole",
                                      class: "tw:mb-4"
                                    }, {
                                      default: a(() => [
                                        t(e(A), {
                                          "button-placement": "both",
                                          disabled: !e(c)(e(n), "hole"),
                                          value: e(l).hole,
                                          "onUpdate:value": o[21] || (o[21] = (d) => e(l).hole = d),
                                          min: 0,
                                          class: "tw:!w-[200px] tw:!text-center",
                                          placeholder: e(i)("请输入整数")
                                        }, null, 8, ["disabled", "value", "placeholder"])
                                      ]),
                                      _: 1
                                    }, 8, ["label"])
                                  ]),
                                  _: 1
                                }),
                                t(e(p), { span: 12 }, {
                                  default: a(() => [
                                    t(e(f), {
                                      label: e(i)("异型斜角帘"),
                                      path: "diagonalCurtain",
                                      class: "tw:mb-4"
                                    }, {
                                      default: a(() => {
                                        var d;
                                        return [
                                          t(e(M), {
                                            disabled: !e(c)(e(n), "diagonalCurtain"),
                                            value: e(l).diagonalCurtain,
                                            "onUpdate:value": o[22] || (o[22] = (s) => e(l).diagonalCurtain = s),
                                            placeholder: e(i)("请选择异型斜角帘"),
                                            options: ((d = e(n).find((s) => s.code === "diagonalCurtain")) == null ? void 0 : d.values) || [],
                                            "label-field": "value",
                                            "value-field": "valueCode",
                                            "key-field": "valueCode",
                                            class: "tw:!w-[200px] tw:!text-left",
                                            to: !1
                                          }, null, 8, ["disabled", "value", "placeholder", "options"])
                                        ];
                                      }),
                                      _: 1
                                    }, 8, ["label"])
                                  ]),
                                  _: 1
                                }),
                                t(e(p), { span: 12 }, {
                                  default: a(() => [
                                    t(e(f), {
                                      label: e(i)("是否平幔遮轨"),
                                      path: "coverRail",
                                      class: "tw:mb-4"
                                    }, {
                                      default: a(() => [
                                        t(e(H), {
                                          disabled: Ne.value,
                                          value: e(l).coverRail,
                                          "onUpdate:value": [
                                            o[23] || (o[23] = (d) => e(l).coverRail = d),
                                            Se
                                          ]
                                        }, {
                                          default: a(() => [
                                            t(e(C), { value: "是" }, {
                                              default: a(() => [
                                                m(r(e(i)("是")), 1)
                                              ]),
                                              _: 1
                                            }),
                                            t(e(C), { value: "否" }, {
                                              default: a(() => [
                                                m(r(e(i)("否")), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["disabled", "value"])
                                      ]),
                                      _: 1
                                    }, 8, ["label"])
                                  ]),
                                  _: 1
                                }),
                                t(e(p), { span: 12 }, {
                                  default: a(() => [
                                    t(e(f), {
                                      label: e(i)("是否顶部飘菲遮轨"),
                                      path: "topCoverRail",
                                      class: "tw:mb-4"
                                    }, {
                                      default: a(() => [
                                        t(e(H), {
                                          disabled: !e(c)(e(n), "topCoverRail"),
                                          value: e(l).topCoverRail,
                                          "onUpdate:value": [
                                            o[24] || (o[24] = (d) => e(l).topCoverRail = d),
                                            D
                                          ]
                                        }, {
                                          default: a(() => [
                                            t(e(C), { value: "是" }, {
                                              default: a(() => [
                                                m(r(e(i)("是")), 1)
                                              ]),
                                              _: 1
                                            }),
                                            t(e(C), { value: "否" }, {
                                              default: a(() => [
                                                m(r(e(i)("否")), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["disabled", "value"])
                                      ]),
                                      _: 1
                                    }, 8, ["label"])
                                  ]),
                                  _: 1
                                }),
                                t(e(p), { span: 12 }, {
                                  default: a(() => [
                                    t(e(f), {
                                      label: e(i)("是否拼搭接高"),
                                      path: "collageHeight",
                                      class: "tw:mb-4"
                                    }, {
                                      default: a(() => [
                                        t(e(H), {
                                          disabled: !e(c)(e(n), "collageHeight"),
                                          value: e(l).collageHeight,
                                          "onUpdate:value": [
                                            o[25] || (o[25] = (d) => e(l).collageHeight = d),
                                            D
                                          ]
                                        }, {
                                          default: a(() => [
                                            t(e(C), { value: "是" }, {
                                              default: a(() => [
                                                m(r(e(i)("是")), 1)
                                              ]),
                                              _: 1
                                            }),
                                            t(e(C), { value: "否" }, {
                                              default: a(() => [
                                                m(r(e(i)("否")), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["disabled", "value"])
                                      ]),
                                      _: 1
                                    }, 8, ["label"])
                                  ]),
                                  _: 1
                                })
                              ], 512), [
                                [el, q.value]
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      t(e(V), null, {
                        default: a(() => [
                          v("div", vl, [
                            t(e(O), {
                              onClick: ie,
                              size: "small"
                            }, {
                              default: a(() => [
                                m(r(e(i)("取消")), 1)
                              ]),
                              _: 1
                            }),
                            t(e(O), {
                              type: "primary",
                              onClick: Ue,
                              size: "small"
                            }, {
                              default: a(() => [
                                m(r(e(i)("确认")), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model", "rules"])
                ]),
                _: 1
              }, 8, ["show"])
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        _: 1
      }, 8, ["show", "to"]),
      t(e(ge), {
        ref_key: "dialog",
        ref: Me,
        bordered: "",
        show: U.value,
        "onUpdate:show": o[32] || (o[32] = (d) => U.value = d),
        "mask-closable": !1,
        to: S.value || "body",
        "z-index": 1e4
      }, {
        default: a(() => [
          t(e(V), {
            bordered: !1,
            title: e(i)("更多尺寸"),
            size: "small",
            closable: "",
            role: "dialog",
            class: "tw:!w-[30%] tw:!text-left",
            onClose: o[31] || (o[31] = (d) => U.value = !1)
          }, {
            default: a(() => [
              t(e(we), {
                model: e(l),
                "label-placement": "left",
                "label-width": "130px",
                class: "tw:!text-left"
              }, {
                default: a(() => [
                  t(e(be), { class: "tw:!flex tw:!justify-center" }, {
                    default: a(() => [
                      t(e(p), { span: 24 }, {
                        default: a(() => [
                          t(e(f), {
                            label: e(i)("左帘宽"),
                            path: "leftCurtainWidth"
                          }, {
                            default: a(() => [
                              t(e(A), {
                                value: e(l).leftCurtainWidth,
                                "onUpdate:value": o[27] || (o[27] = (d) => e(l).leftCurtainWidth = d),
                                "show-button": !1,
                                min: 0,
                                class: "tw:!w-[200px] tw:!text-center",
                                disabled: z.value,
                                placeholder: "t('请输入')"
                              }, {
                                suffix: a(() => o[36] || (o[36] = [
                                  v("span", null, "mm", -1)
                                ])),
                                _: 1
                              }, 8, ["value", "disabled"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      t(e(p), { span: 24 }, {
                        default: a(() => [
                          t(e(f), {
                            label: e(i)("中帘宽"),
                            path: "middleCurtainWidth"
                          }, {
                            default: a(() => [
                              t(e(A), {
                                value: e(l).middleCurtainWidth,
                                "onUpdate:value": o[28] || (o[28] = (d) => e(l).middleCurtainWidth = d),
                                "show-button": !1,
                                min: 0,
                                class: "tw:!w-[200px] tw:!text-center",
                                disabled: E.value,
                                placeholder: e(i)("请输入")
                              }, {
                                suffix: a(() => o[37] || (o[37] = [
                                  v("span", null, "mm", -1)
                                ])),
                                _: 1
                              }, 8, ["value", "disabled", "placeholder"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      t(e(p), { span: 24 }, {
                        default: a(() => [
                          t(e(f), {
                            label: e(i)("右帘宽"),
                            path: "rightCurtainWidth"
                          }, {
                            default: a(() => [
                              t(e(A), {
                                value: e(l).rightCurtainWidth,
                                "onUpdate:value": o[29] || (o[29] = (d) => e(l).rightCurtainWidth = d),
                                "show-button": !1,
                                min: 0,
                                class: "tw:!w-[200px] tw:!text-center",
                                disabled: F.value,
                                placeholder: e(i)("请输入")
                              }, {
                                suffix: a(() => o[38] || (o[38] = [
                                  v("span", null, "mm", -1)
                                ])),
                                _: 1
                              }, 8, ["value", "disabled", "placeholder"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]),
              v("div", ml, [
                t(e(O), {
                  size: "small",
                  onClick: o[30] || (o[30] = (d) => U.value = !1)
                }, {
                  default: a(() => [
                    m(r(e(i)("取消")), 1)
                  ]),
                  _: 1
                }),
                t(e(O), {
                  type: "primary",
                  size: "small",
                  onClick: Ae
                }, {
                  default: a(() => [
                    m(r(e(i)("确认")), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        _: 1
      }, 8, ["show", "to"])
    ], 64));
  }
});
export {
  Ol as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/lianshen/lianshen.vue.js
// module id = 1261
// module chunks = 67